// import React from "react";
// import { Box, Card, CardContent, Typography, Container } from "@mui/material";
// import { styled } from "@mui/system";

// const BookCard = styled(Card)({
//   position: "relative",
//   width: "100%",
//   maxWidth: "300px",
//   height: "400px", // Slightly increased height
//   borderRadius: "10px",
//   transition: "0.3s ease-in-out",
//   backgroundColor: "white",
//   color: "black",
//   display: "flex",
//   flexDirection: "column",
//   boxShadow: "0 4px 6px rgba(0,0,0,0.1)", // Added subtle shadow
//   "&:hover": {
//     backgroundColor: "#f97316",
//     color: "white"
//   },
// });

// const UpperPart = styled(Box)({
//   height: "30%",
//   backgroundColor: "#172554",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   borderTopLeftRadius: "10px",
//   borderTopRightRadius: "10px",
//   color: "white",
//   textAlign: "center",
//   padding: "10px", // Added padding
// });

// const LowerPart = styled(CardContent)({
//   height: "70%",
//   display: "flex",
//   flexDirection: "column",
//   justifyContent: "center",
//   alignItems: "center",
//   textAlign: "center",
//   font: "bold",
//   padding: "15px",
//   overflowY: "auto", // Added scrolling for long descriptions
// });

// const LogoContainer = styled(Box)({
//   width: "80px",
//   height: "80px",
//   backgroundColor: "#fff",
//   borderRadius: "50%",
//   position: "absolute",
//   top: "28%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   fontWeight: "bold",
//   border: "3px solid #f97316",
//   boxShadow: "0 2px 4px rgba(0,0,0,0.2)", // Added shadow
// });

// const ImageContainer = styled("img")({
//   width: "100%",
//   maxWidth: "300px",
//   height: "350px",
//   borderRadius: "10px",
//   objectFit: "cover",
//   boxShadow: "0 4px 6px rgba(0,0,0,0.1)", // Added subtle shadow
// });

// const courses = [
//   { 
//     title: "Robotics & Automation", 
//     description: "Focuses on designing, developing, and implementing robotic systems and automated solutions for various industries, including manufacturing, healthcare, and logistics. Research includes autonomous systems, control mechanisms, and intelligent automation.",
//     logo: "compressed_vecteezy_vibrant-contemporary-robot-repair-automation-maintenance_56763981.png"
//   },
//   { 
//     title: "Artificial Intelligence & Machine Learning", 
//     description: "Explores AI-driven solutions, deep learning models, and intelligent systems capable of making decisions, recognizing patterns, and automating processes across industries such as healthcare, finance, and robotics.",
//     logo: "compressed_vecteezy_a-brain-and-a-computer-chip-with-the-word-ai_54655129.png"
//   },
//   { 
//     title: "Aerospace Engineering", 
//     description: "Covers the design, development, and testing of aircraft, spacecraft, and propulsion systems. Research includes aerodynamics, avionics, satellite technology, and space exploration.",
//     logo: "compressed_vecteezy_airplane-engine-png-design-illustration_8490036.png"
//   },
//   { 
//     title: "Nanotechnology Engineering", 
//     description: "Investigates materials and systems at the nanoscale, enhancing applications in medicine, electronics, and energy. Key research areas include nanomaterials, nanoelectronics, and drug delivery systems.",
//     logo: "compressed_vecteezy_geometric-crystal-orb-futuristic-design-with-glowing-core_56410267.png"
//   },
//   { 
//     title: "Cybersecurity & Network Engineering", 
//     description: "Focuses on protecting systems, networks, and data from cyber threats. Research includes cryptography, ethical hacking, intrusion detection, and network security protocols.",
//     logo: "vecteezy_how-to-protect-your-data-from-cyber-attacks_49671583.png"
//   },
//   { 
//     title: "MBA (Master of Business Administration)", 
//     description: "Emphasizes leadership, strategic management, finance, and marketing. Research areas include business analytics, corporate governance, and organizational behavior.",
//     logo: "compressed_vecteezy_graduation-cap-and-books-academic-achievement_54474147.png"
//   },
//   { 
//     title: "Embedded Systems Engineering", 
//     description: "Deals with designing and developing specialized computing systems for real-time applications. Research includes microcontrollers, firmware development, and system integration for automotive, healthcare, and consumer electronics.",
//     logo: "compressed_vecteezy_beautiful-modern-modern-circuit-board-pattern-green_57155457.png"
//   },
//   { 
//     title: "Wireless Communication & IoT", 
//     description: "Explores wireless networking, Internet of Things (IoT) devices, and sensor networks for smart applications. Key topics include 5G technology, M2M communication, and IoT security.",
//     logo: "compressed_vecteezy_global-network-connectivity-wireless-signal-molecular-structure_56597893.png"
//   }
// ];

// const CoursesPage = () => {
//   return (
//     <Box sx={{ backgroundColor: "#f4f4f4", py: 4 }}> {/* Added background and padding */}
//                 <Typography 
//                 variant="h5" 
//                 fontWeight={600} 
//                 gutterBottom 
//                 textAlign={"center"}
//                 color={"#172554"}
//                 sx={{ fontSize: { xs: "20px", sm: "24px", md: "28px" } }}
//               >
//                 Courses We Offer for{" "}
//                 <span
//                   style={{
//                     background:
//                       "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
//                     padding: "0px 5px",
//                   }}
//                 >
//                   Master's Dissertation
//                 </span>{" "}Writing Services
//               </Typography>
      
//       <Typography 
//         variant="subtitle1" 
//         sx={{ 
//           textAlign: "center", 
//           color: "black", 
//           mb: 4, 
//           px: 2,
//           fontWeight: 500 
//         }}
//       >
//         Comprehensive Academic Support Across Diverse Disciplines
//       </Typography>
      
//       <Container maxWidth="lg">
//         <Box sx={{ 
//           display: "flex", 
//           flexDirection: "column", 
//           alignItems: "center", 
//           gap: { xs: 2, sm: 3, md: 4 } 
//         }}>
//           {/* First Row */}
//           <Box sx={{ 
//             display: "flex", 
//             flexWrap: "wrap", 
//             justifyContent: "center", 
//             gap: { xs: 2, sm: 3 } 
//           }}>
//             {courses.slice(0, 3).map((course, index) => (
//               <BookCard key={index}>
//                 <UpperPart>
//                   <Typography 
//                     variant="h6" 
//                     sx={{ 
//                       color: "white", 
//                       fontWeight: 600,
//                       textAlign: "center",
//                       marginBottom: "10px",
//                     }}
//                   >
//                     {course.title}
//                   </Typography>
//                 </UpperPart>
//                 <LogoContainer>
//                   <img 
//                     src={course.logo} 
//                     alt={course.title} 
//                     width="60" 
//                     height="60" 
//                   />
//                 </LogoContainer>
//                 <LowerPart>
//                   <Typography 
//                     variant="body2" 
//                     sx={{ 
//                       lineHeight: 1.6,
//                       fontSize: "0.95rem", 
//                       textAlign: "justify",
//                     }}
//                   >
//                     {course.description}
//                   </Typography>
//                 </LowerPart>
//               </BookCard>
//             ))}
//           </Box>

//           {/* Second Row with Image */}
//           <Box sx={{ 
//             display: "flex", 
//             flexWrap: "wrap", 
//             justifyContent: "center", 
//             alignItems: "center", 
//             gap: { xs: 2, sm: 3 } 
//           }}>
//             <BookCard>
//               <UpperPart>
//                 <Typography 
//                   variant="h6" 
//                   sx={{ 
//                     color: "white", 
//                     fontWeight: 600,
//                     textAlign: "center",
//                     marginBottom: "10px",
//                   }}
//                 >
//                   {courses[3].title}
//                 </Typography>
//               </UpperPart>
//               <LogoContainer>
//                 <img 
//                   src={courses[3].logo} 
//                   alt={courses[3].title} 
//                   width="60" 
//                   height="60" 
//                 />
//               </LogoContainer>
//               <LowerPart>
//                 <Typography 
//                   variant="body2" 
//                   sx={{ 
//                     lineHeight: 1.6,
//                     fontSize: "0.95rem", 
//                     textAlign: "justify",
//                   }}
//                 >
//                   {courses[3].description}
//                 </Typography>
//               </LowerPart>
//             </BookCard>
//             <ImageContainer 
//               src="1731560790962.jpg" 
//               alt="Courses" 
//             />
//             <BookCard>
//               <UpperPart>
//                 <Typography 
//                   variant="h6" 
//                   sx={{ 
//                     color: "white", 
//                     fontWeight: 600,
//                     textAlign: "center",
//                     marginBottom: "10px",
//                   }}
//                 >
//                   {courses[4].title}
//                 </Typography>
//               </UpperPart>
//               <LogoContainer>
//                 <img 
//                   src={courses[4].logo} 
//                   alt={courses[4].title} 
//                   width="60" 
//                   height="60" 
//                 />
//               </LogoContainer>
//               <LowerPart>
//                 <Typography 
//                   variant="body2" 
//                   sx={{ 
//                     lineHeight: 1.6,
//                     fontSize: "0.95rem", 
//                     textAlign: "justify",
//                   }}
//                 >
//                   {courses[4].description}
//                 </Typography>
//               </LowerPart>
//             </BookCard>
//           </Box>

//           {/* Third Row */}
//           <Box sx={{ 
//             display: "flex", 
//             flexWrap: "wrap", 
//             justifyContent: "center", 
//             gap: { xs: 2, sm: 3 } 
//           }}>
//             {courses.slice(5).map((course, index) => (
//               <BookCard key={index}>
//                 <UpperPart>
//                   <Typography 
//                     variant="h6" 
//                     sx={{ 
//                       color: "white", 
//                       fontWeight: 600,
//                       textAlign: "center",
//                       marginBottom: "10px",
//                     }}
//                   >
//                     {course.title}
//                   </Typography>
//                 </UpperPart>
//                 <LogoContainer>
//                   <img 
//                     src={course.logo} 
//                     alt={course.title} 
//                     width="60" 
//                     height="60" 
//                   />
//                 </LogoContainer>
//                 <LowerPart>
//                   <Typography 
//                     variant="body2" 
//                     sx={{ 
//                       lineHeight: 1.6,
//                       fontSize: "0.95rem", 
//                       textAlign: "justify",
//                     }}
//                   >
//                     {course.description}
//                   </Typography>
//                 </LowerPart>
//               </BookCard>
//             ))}
//           </Box>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default CoursesPage;




import React from "react";
import { Box, Card, CardContent, Typography, Container } from "@mui/material";
import { styled } from "@mui/system";

const BookCard = styled(Card)({
  position: "relative",
  width: "100%",
  maxWidth: "300px",
  height: "400px",
  borderRadius: "10px",
  transition: "background-color 1s ease-in-out, color 0.5s ease-in-out", // Smooth transition
  backgroundColor: "white",
  color: "black",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 4px 6px rgba(0,0,0,0.1)", 
  "&:hover": {
    backgroundColor: "#ff9700",
    color: "blue-900"
  },
});


const UpperPart = styled(Box)({
  height: "30%",
  backgroundColor: "#172554",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
  color: "white",
  textAlign: "center",
  marginBottom: "10px",
  padding: "10px", // Added padding
});

const LowerPart = styled(CardContent)({
  height: "70%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  font: "bold",
  fontSize: "15px",
  fontWeight: 500,
  padding: "20px 15px", // Increased top/bottom padding
  overflowY: "auto", // Added scrolling for long descriptions
});

const LogoContainer = styled(Box)({
  width: "80px",
  height: "80px",
  backgroundColor: "#fff",
  borderRadius: "50%",
  position: "absolute",
  top: "28%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
  border: "3px solid #f97316",
  boxShadow: "0 2px 4px rgba(0,0,0,0.2)", // Added shadow
});

const ImageContainer = styled("img")({
  width: "100%",
  maxWidth: "300px",
  height: "350px",
  borderRadius: "10px",
  objectFit: "cover",
  boxShadow: "0 4px 6px rgba(0,0,0,0.1)", // Added subtle shadow
});

const courses = [
  { 
    title: "Robotics & Automation", 
    description: "Focuses on designing, developing, and implementing robotic systems and automation solutions across industries. Research includes autonomous systems, control mechanisms, and intelligent automation techniques.",
    logo: "compressed_vecteezy_vibrant-contemporary-robot-repair-automation-maintenance_56763981.png"
  },
  { 
    title: "Artificial Intelligence", 
    description: "Explores AI-driven solutions, deep learning models, and intelligent systems for automating processes. Research includes machine learning, pattern recognition, and decision-making applications across industries.",
    logo: "compressed_vecteezy_a-brain-and-a-computer-chip-with-the-word-ai_54655129.png"
  },
  { 
    title: "Data Science", 
    description: "An interdisciplinary field combining statistics, programming, and domain expertise for extracting insights. Research includes data collection, analysis, machine learning, and visualization for decision-making.",
    logo: "vecteezy_robot-hand-using-laptop-hand-of-robot-touching-on-big-data_26567008.png"
  },
  { 
    title: "Data Analytics", 
    description: "Focuses on examining raw data to identify patterns, trends, and insights for informed decisions. Research includes statistical tools, data visualization, and predictive modeling techniques.",
    logo: "compressed_vecteezy_brain-in-robot-hand-on-transparent-background_47117614.png"
  },
  { 
    title: "Cybersecurity", 
    description: "Focuses on protecting systems, networks, and data from cyber threats using advanced security techniques. Research includes cryptography, ethical hacking, intrusion detection, and network security.",
    logo: "vecteezy_how-to-protect-your-data-from-cyber-attacks_49671583.png"
  },
  { 
    title: "Business Analytics", 
    description: "Uses data-driven techniques to analyze business performance and optimize strategies. Research includes statistical analysis, predictive modeling, and business intelligence applications.",
    logo: "compressed_vecteezy_growth-chart-upward-trend-progress-success-data_54715756.png"
  },
  { 
    title: "Embedded Systems", 
    description: "Involves designing specialized computing systems for real-time applications across industries. Research includes microcontrollers, firmware development, and system integration techniques.",
    logo: "compressed_vecteezy_beautiful-modern-modern-circuit-board-pattern-green_57155457.png"
  },
  { 
    title: "Wireless Communication", 
    description: "Explores wireless networks, IoT devices, and sensor technologies for smart applications. Research includes 5G technology, M2M communication, and IoT security solutions.",
    logo: "compressed_vecteezy_global-network-connectivity-wireless-signal-molecular-structure_56597893.png"
  }
];  

const OurSpealizationTopic = () => {
  return (
    <Box sx={{ backgroundColor: "#f4f4f4", py: 4 }}> {/* Added background and padding */}
                <Typography 
                variant="h5" 
                fontWeight={600} 
                gutterBottom 
                textAlign={"center"}
                color={"#172554"}
                sx={{ fontSize: { xs: "20px", sm: "24px", md: "28px" } }}
              >  
                Our Specializations in {" "}
                <span
                  style={{
                    background:
                      "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
                    padding: "0px 5px",
                  }}
                >
                  Advanced Engineering
                </span>{" "}& Technology
              </Typography>
      
      <Typography 
        variant="subtitle1" 
        sx={{ 
          textAlign: "center", 
          color: "black", 
          mb: 4, 
          px: 2,
          fontWeight: 600,
          fontSize: "18px"
        }}
      >
        Expertise in cutting-edge fields driving innovation, research, and real-world applications.
      </Typography>
      
      <Container maxWidth="lg">
        <Box sx={{ 
          display: "flex", 
          flexDirection: "column", 
          alignItems: "center", 
          gap: { xs: 2, sm: 3, md: 4 } 
        }}>
          {/* First Row */}
          <Box sx={{ 
            display: "flex", 
            flexWrap: "wrap", 
            justifyContent: "center", 
            gap: { xs: 2, sm: 3 } 
          }}>
            {courses.slice(0, 3).map((course, index) => (
              <BookCard key={index}>
                <UpperPart>
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      color: "white", 
                      fontWeight: 600,
                      textAlign: "center",
                      width: "100%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      padding: "0 5px",
                    }}
                  >
                    {course.title}
                  </Typography>
                </UpperPart>
                <LogoContainer>
                  <img 
                    src={course.logo} 
                    alt={course.title} 
                    width="60" 
                    height="60" 
                  />
                </LogoContainer>
                <LowerPart>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      lineHeight: 1.7,
                      fontSize: "0.95rem", 
                      textAlign: "left",
                      color: "inherit",
                      marginTop: "25px",
                      height: "100%",
                      width: "100%",
                      display: "-webkit-box",
                      WebkitLineClamp: 7,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {course.description}
                  </Typography>
                </LowerPart>
              </BookCard>
            ))}
          </Box>

          {/* Second Row with Image */}
          <Box sx={{ 
            display: "flex", 
            flexWrap: "wrap", 
            justifyContent: "center", 
            alignItems: "center", 
            gap: { xs: 2, sm: 3 } 
          }}>
            <BookCard>
              <UpperPart>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    color: "white", 
                    fontWeight: 600,
                    textAlign: "center",
                    width: "100%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    padding: "0 5px",
                  }}
                >
                  {courses[3].title}
                </Typography>
              </UpperPart>
              <LogoContainer>
                <img 
                  src={courses[3].logo} 
                  alt={courses[3].title} 
                  width="60" 
                  height="60" 
                />
              </LogoContainer>
              <LowerPart>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    lineHeight: 1.7,
                    fontSize: "0.95rem", 
                    textAlign: "left",
                    color: "inherit",
                    marginTop: "25px",
                    height: "100%",
                    width: "100%",
                    display: "-webkit-box",
                    WebkitLineClamp: 7,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {courses[3].description}
                </Typography>
              </LowerPart>
            </BookCard>
            <ImageContainer 
              src="1731560790962.jpg" 
              alt="Courses" 
            />
            <BookCard>
              <UpperPart>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    color: "white", 
                    fontWeight: 600,
                    textAlign: "center",
                    width: "100%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    padding: "0 5px",
                  }}
                >
                  {courses[4].title}
                </Typography>
              </UpperPart>
              <LogoContainer>
                <img 
                  src={courses[4].logo} 
                  alt={courses[4].title} 
                  width="60" 
                  height="60" 
                />
              </LogoContainer>
              <LowerPart>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    lineHeight: 1.7,
                    fontSize: "0.95rem", 
                    textAlign: "left",
                    color: "inherit",
                    marginTop: "25px",
                    height: "100%",
                    width: "100%",
                    display: "-webkit-box",
                    WebkitLineClamp: 7,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {courses[4].description}
                </Typography>
              </LowerPart>
            </BookCard>
          </Box>

          {/* Third Row */}
          <Box sx={{ 
            display: "flex", 
            flexWrap: "wrap", 
            justifyContent: "center", 
            gap: { xs: 2, sm: 3 } 
          }}>
            {courses.slice(5).map((course, index) => (
              <BookCard key={index}>
                <UpperPart>
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      color: "white", 
                      fontWeight: 600,
                      textAlign: "center",
                      width: "100%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      padding: "0 5px",
                    }}
                  >
                    {course.title}
                  </Typography>
                </UpperPart>
                <LogoContainer>
                  <img 
                    src={course.logo} 
                    alt={course.title} 
                    width="60" 
                    height="60" 
                  />
                </LogoContainer>
                <LowerPart>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      lineHeight: 1.7,
                      fontSize: "0.95rem", 
                      textAlign: "left",
                      color: "inherit",
                      marginTop: "25px",
                      height: "100%",
                      width: "100%",
                      display: "-webkit-box",
                      WebkitLineClamp: 7,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {course.description}
                  </Typography>
                </LowerPart>
              </BookCard>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default OurSpealizationTopic;